import React, { Component, Fragment } from 'react';
import { Accordion, Card, Button } from "react-bootstrap";
import { useAccordionToggle } from "react-bootstrap/AccordionToggle";

import SpanMoreTabTop from "../../images/chevron-top.svg";
import SpanMoreTabDown from "../../images/chevron-down-small.svg";

import ConsentTa from "../../data/consent/ta";
import { CurrencyUtils } from "../../utils";
import ConsentMenu from "../../components/consentMenu";
import DocumentList from "../../components/consentMenu/document-list";
import DocumentData from "../../data/consent/documents/ta";

class ConsentPage extends Component {
  state = {
    benefitHTML: this.buildBenefit(),
    conditionHTML: this.buildCondition(),
    serviceHTML: this.buildService(),
    menuTab: 1,
  };

  componentDidMount() {
    window.scrollTo(0,0);
  }

  onChangeTab(value) {
    this.setState({ menuTab: value });
  }

  buildBenefit() {
    const { benefits } = ConsentTa;

    return benefits.map((benefit, index) => {
      return (
        <Fragment key={index}>
        <Card className="consent-benefit pt-3" >
          <Accordion.Collapse eventKey={`${0}`}>
            <Card.Body>
              <p className="text-blue-light">{benefit.detail}</p>
              {benefit.items.map((item) => {
                return (
                  <Fragment key={item.index}>
                    <p
                      className="normal-text mb-1"
                      dangerouslySetInnerHTML={{ __html: item.index }}
                    ></p>
                    {item.ranges.map((range) => {
                      return (
                        <Fragment key={range.name}>
                          <p className="range-text mb-2">{range.name}</p>
                          {range.plans.map((plan) => {
                            return (
                              <Fragment key={plan.name}>
                                <div className="price-text">
                                  <span>{plan.name}</span>
                                  <p className="mb-0 ml-auto">{plan.price}</p>
                                </div>
                              </Fragment>
                            );
                          })}
                        </Fragment>
                      );
                    })}
                  </Fragment>
                );
              })}
              <div className="line-gray"></div>
              <p className="text-blue-light">ระยะเวลาเอาประกันภัย</p>
              {benefit.times.map((time) => {
                return (
                  <Fragment key={time.day}>
                    <p className="range-text mb-1">{time.day}</p>
                    <span className="text-sub">เบี้ยประกันภัย (บาท)</span>
                    <div className="table-time">
                      <table width="100%">
                        <thead>
                          <tr className="t-head">
                            {benefit.timesHeaders.map((e,i) => (
                              <Fragment key={i}>
                                <td className="text-center">{e}</td>
                              </Fragment>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="t-body">
                            {benefit.timesHeaders.map((e,i) => (
                              <Fragment key={i}>
                              <td className="text-center">
                                {CurrencyUtils.currency(time.price[e])}
                              </td>
                              </Fragment>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Fragment>
                );
              })}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        </Fragment>
      );
    });
  }

  buildCondition() {
    const { conditions } = ConsentTa;
    return conditions.map((condition, index) => {
      return (
        <Fragment key={index}>
        <Card className="consent-benefit pt-3">
          <Accordion.Collapse eventKey={`${0}`}>
            <Card.Body>
              <p className="text-blue-light">{condition.detail}</p>
              {condition.items.map((item) => {
                return (
                  <Fragment key={item.index}>
                    <label
                      className="normal-text mb-1"
                      dangerouslySetInnerHTML={{ __html: item.index }}
                    ></label>
                  </Fragment>
                );
              })}
              {this.Exception()}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        </Fragment>
      );
    });
  }

  Exception() {
    const { exceptions } = ConsentTa;
    return exceptions.map((exception, index) => {
      return (
        <Fragment key={index}>
        <div className="consent-benefit">
          <p className="text-blue-light mt-3">{exception.detail}</p>
          {exception.items.map((item) => {
            return (
              <Fragment key={item.index}>
                <label className="normal-text mb-1">{item.index}</label>
              </Fragment>
            );
          })}
        </div>
        </Fragment>
      );
    });
  }

  buildService() {
    const { services } = ConsentTa;
    return services.map((service, index) => {
      return (
        <Fragment key={index}>
        <Card className="consent-benefit">
          <Accordion.Collapse eventKey={`${0}`}>
            <Card.Body>
              <p
                className="text-blue-light mt-3"
                dangerouslySetInnerHTML={{ __html: service.detail }}
              ></p>
              {service.items.map((item) => {
                return (
                  <Fragment key={item.index}>
                    <label
                      className="normal-text mb-0"
                      dangerouslySetInnerHTML={{ __html: item.index }}
                    ></label>
                  </Fragment>
                );
              })}
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        </Fragment>
      );
    });
  }
  
  render() {
    const { benefitHTML, conditionHTML, serviceHTML, menuTab } = this.state;
    return (
      <div className="consent">
        <div className="consent-panel normal-text">
          <h5>{ConsentTa.title}</h5>
          <p
            dangerouslySetInnerHTML={{ __html: ConsentTa.description }}
          ></p>
        </div>
        <div className="consent-panel mb-0 pb-5">
          <ConsentMenu
            onChangeTab={(value) => this.onChangeTab(value)}
            menuTab={menuTab}
          />
          {menuTab === 1 ? (
            <div className="tab-content">
              <Accordion defaultActiveKey="0">{benefitHTML}</Accordion>
            </div>
          ) : menuTab === 2 ? (
            <div className="tab-content">
              <Accordion defaultActiveKey="0">{conditionHTML}</Accordion>
            </div>
          ) : menuTab === 3 ? (
            <div className="tab-content">
              <Accordion defaultActiveKey="0">{serviceHTML}</Accordion>
              <div className="mt-5 text-center">
                <button
                  className="btn btn-primary btn-block"
                  style={{ backgroundColor: "#55b3f9", borderRadius: "20px", border: "1px solid #55b3f9" }}
                  onClick={() => { window.location.href = "https://www.mticonnect.com/Contact/Information/Ta" }}
                >
                  ติดต่อสอบถาม
                </button>
              </div>
            </div>
          ) : menuTab === 4 ? (
            <div className="tab-content">
              <Accordion defaultActiveKey="0">
                <DocumentList data={DocumentData}/>
              </Accordion>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    )
  }
}
export default ConsentPage;